module.exports = __webpack_public_path__ + "img/manda_007.f2da184f.png";